import posthog from "posthog-js"

posthog.init(window._env_.POSTHOG_API_KEY, {
  api_host: window._env_.POSTHOG_API_ENDPOINT,
})

// Override feature flags for testing purposes
// Usage:
//  1. Uncomment the below code block
//  2. Change the flag value to true/false as needed
//  3. Save and reload, or wait for hot reload of, the app
// import { FeatureFlag } from "./domain/enums/featureFlags"
// posthog.featureFlags.override({
//   [FeatureFlag.IsDirectusOverrideEnabled]: false,
// })

export { posthog }
